import React from "react"
import { FormattedMessage, FormattedNumber } from "react-intl"
import Icon from "../../../../common/icon/icon.component"
import Integrations from "../../../../integration/Integrations"
import IntlProps from "../../../../state/helpers/IntlProps"
import { PAYMENT_STATUS, PAYMENT_TYPE } from "../../../../state/helpers/Payment"
import { INTEGRATIONS_PAYMENT_REFUND_SUPPORT } from "../../../../state/integration/Constants"
import PaymentTransaction from "../../../../state/payment/PaymentTransaction"

export const DetachPaymentButtonMessage = (props: { paymentTransaction: PaymentTransaction } & IntlProps) => {
    const paymentStatus = props.paymentTransaction.getPayment().getStatus()

    switch (paymentStatus) {
    case PAYMENT_STATUS.PENDING: return (
        <>
            <Icon className={"mr-1"} value={"ban"} />
            <FormattedMessage
                id="invoice.analytics.events.payment_received.void_pending_btn"
                defaultMessage="Void pending payment"
            />
        </>
    )
    case PAYMENT_STATUS.CAPTURED: return (
        <>
            <Icon className={"mr-1"} value={"trash"} />
            <FormattedMessage
                id="invoice.analytics.events.payment_received.detach_btn"
                defaultMessage="Detach payment"
            />
        </>
    )
    default: return <></>
    }
}

export const DetachPaymentModalMessage = (props: {
    paymentTransaction: PaymentTransaction,
    documentID: string,
} & IntlProps) => {
    const payment = props.paymentTransaction.getPayment()
    const integratedPaymentIntegrationKey = payment.getIntegratedPaymentIntegrationKey()

    if (props.paymentTransaction.isDetachable()) {
        return <span>
            <FormattedMessage
                id="invoice.analytics.events.payment_received.payment_transaction_detach_message"
                defaultMessage="Are you sure you want to detach this payment of {amount} from this document ?"
                values={{
                    amount: <strong>
                        <FormattedNumber
                            value={props.paymentTransaction.getAmount()}
                            style={"currency"}
                            currency={props.paymentTransaction.getCurrency()}
                        />
                    </strong>
                }}
            />
            <em>
                <br />
                <br />
                <Icon className={"mr-1 text-warning"} value={"info"} />
                <FormattedMessage
                    id="invoice.analytics.events.payment_received.detach_warning"
                    // eslint-disable-next-line max-len
                    defaultMessage="By detaching this payment from {documentID}, you are creating a credit memo that will be available on the contact’s account."
                    values={{
                        documentID: <strong>{props.documentID}</strong>,
                    }}
                />
            </em>
        </span>
    }

    if (!props.paymentTransaction.hasVoidablePendingPayment()) {
        return <></>
    }

    const paymentType = payment.getType()
    const paymentAmount = payment.getAmount()
    const paymentCurrency = payment.getCurrency()

    switch (paymentType) {
    case PAYMENT_TYPE.BANK_TRANSFER: return (
        <>
            <p>
                <FormattedMessage
                    id="invoice.analytics.events.payment_received.void_modal_ach_message1"
                    defaultMessage="Do you want to void this pending Bank Transfer of {amount}?"
                    values={{
                        amount: <FormattedNumber
                            style="currency"
                            currency={paymentCurrency}
                            value={paymentAmount}
                        />,
                    }}
                />
            </p>
            {
                INTEGRATIONS_PAYMENT_REFUND_SUPPORT.includes(integratedPaymentIntegrationKey) ?
                    <p>
                        <Icon className={"mr-1 text-warning"} value={"exclamation"} />
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.void_modal_ach_message2"
                            // eslint-disable-next-line max-len
                            defaultMessage="Voiding a pending bank transfer is not instant. The funds may already have been withdrawn from the payer’s account and may take up to 5 business days to be refunded."
                        />
                    </p>
                    :
                    <p>
                        <Icon className={"mr-1 text-warning"} value={"exclamation"} />
                        <FormattedMessage
                            id="invoice.analytics.events.payment_received.void_modal_ach_message3"
                            // eslint-disable-next-line max-len
                            defaultMessage="This action will void the payment in QuoteMachine but won't automatically void it in your payment processor. The payment also has to be voided or refunded in {integrationName}."
                            values={{
                                integrationName: Integrations.getIntegrationNameFromKey(integratedPaymentIntegrationKey)
                            }}
                        />
                    </p>
            }
        </>
    )
    case PAYMENT_TYPE.CREDIT_CARD: return (
        <>
            <Icon className={"mr-1"} value={"trash"} />
            <FormattedMessage
                id="invoice.analytics.events.payment_received.void_modal_cc_message"
                defaultMessage="Do you want to void this pending Credit Card payment of {amount}?"
                values={{
                    amount: <FormattedNumber
                        style="currency"
                        currency={paymentCurrency}
                        value={paymentAmount}
                    />,
                }}
            />
        </>
    )
    case PAYMENT_TYPE.EXTERNAL_CHECKOUT: return (
        <>
            <Icon className={"mr-1"} value={"trash"} />
            <FormattedMessage
                id="invoice.analytics.events.payment_received.void_modal_external_checkout_message"
                defaultMessage="Do you want to cancel this pending external checkout ?"
                values={{
                    amount: <FormattedNumber
                        style="currency"
                        currency={paymentCurrency}
                        value={paymentAmount}
                    />,
                }}
            />
        </>
    )
    default: return (
        <>
            <>
                <Icon className={"mr-1"} value={"trash"} />
                <FormattedMessage
                    id="invoice.analytics.events.payment_received.void_modal_generic_message"
                    defaultMessage="Do you want to void this pending payment of {amount}?"
                    values={{
                        amount: <FormattedNumber
                            style="currency"
                            currency={paymentCurrency}
                            value={paymentAmount}
                        />,
                    }}
                />
            </>
        </>
    )
    }
}


// WEBPACK FOOTER //
// ./src/quote/analytics/events/Utils/VoidPendingPaymentInfo.tsx